import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const peso = (value) =>
  new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
  }).format(value || 0);

export default function Settlement() {
  const [items, setItems] = useState([]);
  const [period, setPeriod] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const { data } = await api.get(`/api/admin/settlements?period_type=${period}`);
    setItems(data);
    setBusy(false);
  };

  useEffect(() => {
    load();
  }, [period]);

  const approve = async (id) => {
    await api.post(`/api/admin/settlements/${id}/approve`);
    toast.success("Settlement approved");
    load();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="text-[var(--text-2)] text-sm">
          Daily / weekly / monthly settlement batches with GGR, NGR and revenue share splits.
        </div>

        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm"
        >
          <option value="">All periods</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto">
          <table className="aggr-table">
            <thead>
              <tr>
                <th>Period</th>
                <th>Operator</th>
                <th>GGR</th>
                <th>NGR</th>
                <th>Agg Share</th>
                <th>Provider Share</th>
                <th>Operator Share</th>
                <th>Adjustments</th>
                <th>Net Payable</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {busy && (
                <tr>
                  <td colSpan={11} className="text-center py-6">
                    <Loader2 className="inline animate-spin" size={14}/>
                  </td>
                </tr>
              )}

              {!busy && items.map(s => (
                <tr key={s.id}>
                  <td className="text-xs">
                    <span className="badge badge-muted">{s.period_type}</span>
                    <span className="text-[var(--text-3)] ml-1">
                      {s.period_end.slice(0, 10)}
                    </span>
                  </td>

                  <td className="font-mono text-xs">{s.operator_id}</td>

                  <td className="font-mono">{peso(s.ggr)}</td>
                  <td className="font-mono">{peso(s.ngr)}</td>
                  <td className="font-mono text-[var(--gold)]">{peso(s.aggregator_share)}</td>
                  <td className="font-mono">{peso(s.provider_share)}</td>
                  <td className="font-mono">{peso(s.operator_share)}</td>
                  <td className="font-mono">{peso(s.adjustments)}</td>
                  <td className="font-mono font-semibold">{peso(s.net_payable)}</td>

                  <td><StatusBadge status={s.status}/></td>

                  <td>
                    {s.status === "draft" && (
                      <button
                        onClick={() => approve(s.id)}
                        className="btn-ghost px-2 py-1 rounded text-xs flex items-center gap-1"
                      >
                        <Check size={11}/> Approve
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
}
